import { SingleFieldDynamicFields } from '../singleFieldDynamicFields';
import { FormikProps } from 'formik';
import { Box, Typography } from '@mui/material';
import { SingleDynamicField } from '../../../../../shared/types/assistant';

export const EscalationAndCaseHandling = ({
    formikEscalationAndCaseHandling,
}: {
    formikEscalationAndCaseHandling: FormikProps<{
        [key: string]: SingleDynamicField[];
    }>;
}) => {
    return (
        <SingleFieldDynamicFields
            formik={formikEscalationAndCaseHandling}
            name="escalationAndCaseHandling"
            label="Protocolos de Escalamiento y Manejo de Casos"
            description="Especifica los criterios y procedimientos para el escalamiento y manejo de casos, asegurando que las consultas sean atendidas de manera eficiente. Define en qué situaciones el asistente debe escalar un caso, a quién debe dirigirlo y qué acciones debe seguir en cada etapa."
            example={
                <Box display="flex" flexDirection="column" padding={2}>
                    <Typography color="text.secondary">
                        Caso 1: Información no en la Base de Conocimiento
                    </Typography>
                    <Typography color="text.secondary">
                        🔹 Escalar con mensaje claro.
                    </Typography>
                </Box>
            }
            rows={1}
        />
    );
};
